<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">Home</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-md-4">
          <div class="inner-box">
            <label>Total Amount</label><br>
            <label>{{ord?.totalAmount}}</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="inner-box">
            <label>Amount Collected</label><br>
            <label>{{ord?.amountCollected}}</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="inner-box">
            <label>Amount To be Paid</label><br>
            <label>{{ord?.amountToBePaid}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="row align-items-center mt-2">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of ordersMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus);resetCheckedList(); tabChange()"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
        </ul>
      </div>
      <div class="col text-right">
        <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile" style="margin-top: -14px;">
          Actions
        </button>

        <div class="dropdown-menu dropdown-menu2  dropdown-menu-right">
          <a *ngIf="tabClicked === 'toBePaid'" class="dropdown-item file btn shift-import" (click)="paymentProcess()">Process Payment</a>
          <a *ngIf="tabClicked === 'paid'" class="dropdown-item file btn shift-import" (click)="saveCodInfo()">Mark as Unpaid</a>
        </div>
      </div>
      <div class="col-md-3">
        <ng-select id="contactName" [(ngModel)]="name" (change)="getApiData(orderStatus)" required
                   [ngModelOptions]="{standalone: true}"
                   [items]="accountOwners"
                   bindLabel="companyName"
                   [searchFn]="customSearchFn"
                   placeholder="Search "
                   [searchWhileComposing]="true">
          <ng-template ng-option-tmp let-item="item">
            {{item?.companyName}} <br/>
            <small>{{item?.name}}</small>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block">
        <table id="tables_id" class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" width="100%">
          <thead>
          <tr>
            <th></th>
            <th>Order Number</th>
            <th>Order Amount</th>
            <th>User Name</th>
            <th>Carrier Name</th>
            <th>CompanyName</th>
            <th>Collected Date</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of orders">

            <td>
              <div class="form-checkbox" *ngIf="(checkboxDisplay == 'Y' && tabClicked == 'toBePaid') || (checkboxDisplay == 'Y' && tabClicked == 'paid')"><input
                type="checkbox" id="{{o.orderNumber}}" [(ngModel)]="o.isSelected" name="list_name"
                (change)="selectShip(o)">
                <label for="{{o.orderNumber}}"></label></div>
            </td>
            <td>{{o.orderNumber}}</td>
            <td>₹{{o.orderAmount}}</td>
            <td>{{o.customerName || o.userName}}</td>
            <td>{{o.carrierName || (o.shippingOption == 'SD' ? 'Shift' :
              (o.shippingOption == 'DL' ? 'Delhivery' :
              (o.shippingOption == 'GT' ? 'Gati' :
              (o.shippingOption == 'DZ' ? 'Dotzot' :
              (o.shippingOption == 'RD' ? 'Rapid Delivery' :
              (o.shippingOption == 'SF' ? 'Shadow Fax' :
              (o.shippingOption == 'BD' ? 'Blue Dart' :
              (o.shippingOption == 'PR' ? 'Pickrr' :
              (o.shippingOption == 'SY' ? 'Ship Yaari' :
              (o.shippingOption == 'DE' ? 'Delhivery' :
              (o.shippingOption == 'SG' ? 'Shippigo' :
              (o.shippingOption == 'VS' ? 'Vamaship' :
              (o.shippingOption == 'DN' ? 'Dunzo' :
              (o.shippingOption == 'WF' ? 'Borzo' :
              (o.shippingOption == 'FE' ? 'FedEx' : o.shippingOption))))))))))))))) || '--'}}</td>
            <td>{{o.customerCompanyName || o.companyName}}</td>
            <td>{{o.collectedDate || o.deliveryDate || '--'}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
